<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TmBSM/tc-custom/9780547347882.jpg?1734279932538" alt="This image is the cover for the book Live Through This"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Live Through This
      </h1>
      <p class="bookDescription body article font2">
        <b>An “achingly beautiful” memoir about a mother’s mission to rescue her two teenage daughters from the streets and bring them back home (<i>Kirkus Reviews</i>, starred review).</b><br/><br/> After a miserably failed marriage, Debra Gwartney moves with her four young daughters to Eugene, Oregon, for a new job and what she hopes will be a new life for herself and her family. But the two oldest, fourteen-year-old Amanda and thirteen-year-old Stephanie, blame their mother for what happened, and one day the two run off together—to the streets of their own city, then San Francisco, then nowhere to be found.<br/>  <br/> The harrowing subculture of the American runaway, with its random violence, its dangerous street drugs, and its patchwork of hidden shelters, is captured with brilliant intensity in <i>Live Through This</i> as this panicked mother sets out to find her girls—examining her own mistakes and hoping against hope to bring them home and become a family again, united by forgiveness and love.<br/> “For all the raw power of this true story and the fearless honesty of the voice telling it, what sticks out for me is the literary craft that shapes every sentence. Debra Gwartney has seen clear to the bottom of her experience, purged it of self-righteousness, and emerged with a stunningly humane and humbled awareness of life’s troubles” —Phillip Lopate
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Debra Gwartney
      </h2>
      
      <p class="authorDescription body article">Debra Gwartney is a former the <I>Oregonian</I> newspaper reporter and worked as a correspondent for <I>Newsweek</I> magazine for ten years. She teaches writing at Portland State University. Gwartney is the mother of four daughters and is married to writer Barry Lopez.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8adc0bca